import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'Utils/googleAnalytics';

export const GoogleAnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(
      `${location.pathname}${location.search}${location.hash}`,
    );
  }, [
    location.pathname,
    location.search,
    location.hash,
  ]);

  return null;
};
